import { ProductName } from '@pypestream/api-services';
import { TranslationKeys } from './types';

export const ToolsTranslationMapper: {
  [key in ProductName]: TranslationKeys;
} = {
  [ProductName.Organization]: 'manager/common:products.manager',
  [ProductName.AgentAssist]: 'manager/common:products.agentAssist',
  [ProductName.Analytics]: 'manager/common:products.analytics',
  [ProductName.ProStudio]: 'manager/common:products.proStudio',
};

export const ToolsDescriptionTranslationMapper: {
  [key in ProductName]: TranslationKeys;
} = {
  [ProductName.Organization]: 'manager/common:products.managerDescription',
  [ProductName.AgentAssist]: 'manager/common:products.agentAssistDescription',
  [ProductName.Analytics]: 'manager/common:products.analyticsDescription',
  [ProductName.ProStudio]: 'manager/common:products.proStudioDescription',
};
